import { Http, RequestOptions, XHRBackend } from "@angular/http";
import { InterceptedHttp } from "./http.interceptor";
import { Store } from "@ngrx/store";
import { SpinnerService } from "./shared/services/spinner/spinner.service";

export function httpFactory(
  xhrBackend: XHRBackend,
  requestOptions: RequestOptions,
  store: Store<any>,
  spinnerService: SpinnerService
): Http {
  return new InterceptedHttp(xhrBackend, requestOptions, store, spinnerService);
}



// WEBPACK FOOTER //
// ./src/app/http.factory.ts